import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ApolloProvider } from '@apollo/react-common';
import 'focus-visible/dist/focus-visible';

import './theme';
import getApolloClient from './apollo-client';
import setupUserStore from './user-store';
import Router from './router';
import getHistory, { getHistoryInstance } from './history';

import { translationMessages } from './i18n';
import LanguageProvider from './providers/LanguageProvider';
import PageTitleProvider from './providers/PageTitleProvider';
import HotReloadContainer from './hot-reload-container';
import setupGA from './configureGA';

const appDom = document.getElementById('app');

console.log(`Starting HE App @ ${process.env.VERSION}, built ${process.env.BUILDTIME} from ${process.env.BUILDBRANCH}`); // eslint-disable-line no-console

const renderUI = (store) => {
  const history = getHistory(store);
  const client = getApolloClient(store);
  if (process.env.A11Y === 'true') {
    require('./a11y').default(appDom); // eslint-disable-line global-require
  }
  // Render the main app react component into the app div.
  function renderDOM(CurrentRouter) {
    ReactDOM.render(
      <HotReloadContainer>
        <Provider store={store}>
          <LanguageProvider messages={translationMessages}>
            <ApolloProvider client={client}>
              <PageTitleProvider>
                <CurrentRouter history={history} />
              </PageTitleProvider>
            </ApolloProvider>
          </LanguageProvider>
        </Provider>
      </HotReloadContainer>,
      appDom,
    );
  }
  renderDOM(Router);
  if (module.hot) {
    module.hot.accept('./router', () => {
      ReactDOM.unmountComponentAtNode(appDom);
      renderDOM(require('./router').default); // eslint-disable-line
    });
  }
};
setupGA(getHistoryInstance());
setupUserStore(renderUI);
